import type { ReactNode } from "react";
import { LegalPage } from "./LegalPage";

interface CustomerMethodologyPageProps {
  title: string;
  description: string;
  path: string;
  children: ReactNode;
}

/** High-level, customer-facing methodology copy — no schema, endpoint, or pipeline detail. */
export function CustomerMethodologyPage({
  title,
  description,
  path,
  children,
}: CustomerMethodologyPageProps) {
  return (
    <LegalPage
      title={title}
      eyebrow="Trust center"
      description={description}
      path={path}
      effective="2026-05-31"
    >
      {children}
      <p className="mt-8 text-sm text-ink-500">
        Detailed implementation documentation is available to active customers under
        NDA. Contact{" "}
        <a href="mailto:hello@weconsultrx.com">hello@weconsultrx.com</a> for
        security or compliance review materials.
      </p>
    </LegalPage>
  );
}
